<template>
  <div>
    <div>
      <main-header />
      <!-- *********************** Load the parcel details *********************************** -->
      <parcel-detail-content :parcel-key="parcelID" @detailClosed="onDetailClosed" />
    </div>
    <message-modal />
  </div>
</template>
<script>
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  mixins: [Helpers],
  data () {
    return {
      parcelID: -1,
      constants
    }
  },
  watch: {
    $route (to, from) {
      this.$router.go()
    }
  },
  created () {
    this.get_Parcel()
  },
  methods: {
    onDetailClosed () {
      this.$router.push('/parcel-list')
    },
    get_Parcel () {
      // Get the Parcel Details
      this.parcelID = this.$route.params.id
    }
  }
}
</script>

<style lang="scss">
.parcel_action_bar_spacer {
  height: 70px;
}
</style>
